import { useMemo } from 'react'

import { Icon, TreeItem } from '@graftcode/design-system'

import { mapLibraryToTreeItem } from '@/core/utils/tree'

import { useLibraries } from './useLibraries'

export function useVisionLibraryTree(): TreeItem[] {
  const { gateway, libraries, projectName, isLoading } = useLibraries()

  return useMemo((): TreeItem[] => {
    if (isLoading || Object.keys(libraries).length === 0) {
      return []
    }

    return [
      {
        id: 'root',
        label: projectName || gateway || 'Library',
        icon: Icon.DSCodeGateway,
        type: 'root',
        children: Object.values(libraries).map(mapLibraryToTreeItem),
      },
    ]
  }, [projectName, gateway, libraries, isLoading])
}
